// extracted by mini-css-extract-plugin
module.exports = {"row":"CustomCalendarWeekHead_row__0JoTb","day":"CustomCalendarWeekHead_day__F5Phk"};